var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteCallActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "compound_shape_1_",
    className: "st0",
    d: "M16.8,16h4c0.4,0,0.8,0.4,0.8,0.8v4c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8 v-4C16,16.3,16.3,16,16.8,16z M10,16h4c0.4,0,0.8,0.4,0.8,0.8v4c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8v-4 C9.2,16.3,9.6,16,10,16z M3.2,16h4C7.7,16,8,16.3,8,16.8v4c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8v-4 C2.4,16.3,2.8,16,3.2,16z M16.8,9.2h4c0.4,0,0.8,0.4,0.8,0.8v4c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8v-4 C16,9.6,16.3,9.2,16.8,9.2z M10,9.2h4c0.4,0,0.8,0.4,0.8,0.8v4c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8v-4 C9.2,9.6,9.6,9.2,10,9.2z M3.2,9.2h4C7.7,9.2,8,9.6,8,10v4c0,0.4-0.4,0.8-0.8,0.8h-4c-0.4,0-0.8-0.4-0.8-0.8v-4 C2.4,9.6,2.8,9.2,3.2,9.2z M16.8,2.4h4c0.4,0,0.8,0.4,0.8,0.8v4c0,0.4-0.4,0.8-0.8,0.8h-4C16.3,8,16,7.7,16,7.2v-4 C16,2.8,16.3,2.4,16.8,2.4z M10,2.4h4c0.4,0,0.8,0.4,0.8,0.8v4C14.8,7.7,14.4,8,14,8h-4C9.6,8,9.2,7.7,9.2,7.2v-4 C9.2,2.8,9.6,2.4,10,2.4z M3.2,2.4h4C7.7,2.4,8,2.8,8,3.2v4C8,7.7,7.7,8,7.2,8h-4C2.8,8,2.4,7.7,2.4,7.2v-4C2.4,2.8,2.8,2.4,3.2,2.4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteCallActive);
export default __webpack_public_path__ + "static/media/invite_call_active.f4f750fff4c8ada18b40d3263030f7c6.svg";
export { ForwardRef as ReactComponent };